import { EOfferSeller } from '../../../../../../../packages/api-models/common/json_query';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter/components/AdvancedFilterRow';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectOfferSellerFilter } from 'shared/selectors/advancedFilters';
import { MultiSelectionAdvancedFilter, SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { NonEmptyArray } from '../../../../../../../packages/JsonQuery';

export const OfferSellerContainer: FC = () => {
  const { label, value, options } = useSelector(selectOfferSellerFilter);

  const onChange = useFilterChangeCallback();

  const handleOfferSellersChange = useCallback(
    (newValue: NonEmptyArray<EOfferSeller> | null) => {
      onChange({ action: 'setOfferSeller', arguments: [newValue] });
    },
    [onChange],
  );

  const handleOfferSellerChange = useCallback(
    (newValue: EOfferSeller | null) => {
      handleOfferSellersChange(newValue ? [newValue] : null);
    },
    [handleOfferSellersChange],
  );

  const optionsCountWithoutNone = options.length - 1;

  return (
    <AdvancedFilterRow label={label}>
      {optionsCountWithoutNone > 2 ? (
        <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleOfferSellersChange} />
      ) : (
        <SingleSelectionAdvancedFilter value={value} options={options} onFilterChange={handleOfferSellerChange} />
      )}
    </AdvancedFilterRow>
  );
};
